<template>
<div class="load">
  <van-loading size="12px">加载中...</van-loading>
</div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  props: ['text'],
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.load {
    text-align: center;
    padding: 25px 0;
    color: #999;
}
</style>
